import {DropdownButton, MenuItem} from 'react-bootstrap'
import styles from './DropdownButtonSelectIcon.css'
class DropdownButtonSelectIcon extends React.Component {
  render () {
    const {options, disabled} = this.props
    return (<DropdownButton title={this._label()} onSelect={this._onSelect} disabled={disabled}>
      {options.map((o) => {
        return <MenuItem eventKey={o.id}>
          <i className={o.icon + ' ' + styles.icon} />
          <span className={styles.status}> {o.name}</span>
        </MenuItem>
      })}
    </DropdownButton>)
  }

  _onSelect = (eventKey, event) => {
    const {input: {onChange, value}, isDirtyForm, onDirtyFormCallback} = this.props
    if (isDirtyForm) {
      onDirtyFormCallback(event, eventKey, value)
    } else {
      onChange(eventKey)
    }
  }

  _label = () => {
    const {input: {value}, options} = this.props
    let res = 'Loading...'
    options.forEach((o) => {
      if (o.id === value) {
        res = o.name
      }
    })
    return res
  }
}

export default DropdownButtonSelectIcon



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/DropdownButtonSelectIcon/DropdownButtonSelectIcon.js